// Drawer.js
import React from "react";
import { styled } from "@mui/material/styles";
import { useTheme, useMediaQuery } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AdministratorMenu from "../Menus/AdministratorMenu";
import CompanyMenu from "../Menus/CompanyMenu";
import PublicMenu from "../Menus/PublicMenu";
import useStore from "hooks/useStore";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "mobile",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

function DrawerContent({ open, toggleDrawer }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const selectedCompany = useStore((state) => state.selectedCompany);
  const isUserAdministrator = useStore((state) => state.isUserAdministrator)();
  const isUserPublic = useStore((state) => state.isUserPublic)();

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      onClose={toggleDrawer}
      open={open}
      mobile={isMobile}
      ModalProps={{
        keepMounted: true,
        disableScrollLock: true,
      }}
    >
      <Toolbar
        sx={{
          minHeight: "95px !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: [1],
        }}
      >
        <>
          {open && (
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              style={{ height: "95px" }}
              alt="Logo"
            />
          )}
        </>
        <IconButton onClick={toggleDrawer}>
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Toolbar>
      <Divider />
      {/* Make the List scrollable */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <List component="nav">
          {isUserAdministrator && (
            <>
              <AdministratorMenu toggleDrawer={toggleDrawer} />
              <Divider sx={{ my: 1 }} />
            </>
          )}
          {(!isUserAdministrator || selectedCompany) && !isUserPublic && (
            <>
              <CompanyMenu toggleDrawer={toggleDrawer} />
              <Divider sx={{ my: 1 }} />
            </>
          )}
          {isUserPublic && (
            <>
              <PublicMenu toggleDrawer={toggleDrawer} />
              <Divider sx={{ my: 1 }} />
            </>
          )}
        </List>
      </Box>
    </Drawer>
  );
}

export default DrawerContent;
